<script lang="ts" context="module">
  import { getAppConfig } from '../../../../common/config/app-config';
  import AtcJoodVasPrimeDetailsDiscount from './AtcJoodVasPrimeDetailsDiscount.svelte';
  import AtcJoodVasPrimeDetailsWallet from './AtcJoodVasPrimeDetailsWallet.svelte';
</script>

<script lang="ts">
  export let vasPrice;
  export let joodType;
  export let oldVasPrice = null;
  export let vasLabel;
  export let vasName = '';
  export let isNoPlan = false;
  // const joodCardImageUrl = getJoodCardImageUrlNew(getJoodMembershipType());

  const { benefitType = 'DISCOUNT' } = getAppConfig();
  const atcJoodVasPrimeDetailsComponent =
    benefitType === 'WALLET' ? AtcJoodVasPrimeDetailsWallet : AtcJoodVasPrimeDetailsDiscount;
</script>

<svelte:component
  this={atcJoodVasPrimeDetailsComponent}
  {vasPrice}
  {joodType}
  {oldVasPrice}
  {vasLabel}
  {vasName}
  {isNoPlan}
/>
